import { Component, OnInit, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges, Input } from '@angular/core';
import { DatePipe, NgStyle } from '@angular/common';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSnackBar } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CookieService } from 'ngx-cookie-service';

import { StaffActivityService } from '../service/staffactivity.service';
import { EmployeeDataService } from '../service/employeedata.service';
import { ErrorDialogComponent } from '../dialog/errordialog/error.dialog.component';
import { SaveDialogComponent } from '../dialog/savedialog/save.dialog.component';
import { BaseService } from '../service/base.service';
import { UserLoginService } from '../service/aws/user.login.service';

import * as jspdf from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { integer } from 'aws-sdk/clients/cloudfront';

@Component({
  selector: 'app-employee-engagementdashboard',
  styleUrls: ['dashboard.component.scss'],
  templateUrl: './dashboard.component.html',
})

export class DashboardComponent implements OnInit {
  @Input() dataSource: any;
  @Input() dataSourceOtherPeople: any;
  @Input() myEmployees: any;
  @Input() otherPeople: any;

  // My staff table
  @ViewChild(MatPaginator) paginatorMyStaff: MatPaginator;
  @ViewChild(MatSort) sortMyStaff: MatSort;

  // Other people table
  @ViewChild(MatPaginator) paginatorOtherPeople: MatPaginator;
  @ViewChild(MatSort) sortOtherPeople: MatSort;

  loading: boolean;
  staffActivityId: any;
  employeeData: any;
  allEmployees: any;
  otherPeopleEmployees: any;
  selectedOther: any;
  userName: string;
  employeeDataFromEsb: any;
  displayedColumns: string[] = [
    'name',
    'comments',
    'oneToOne',
    'projects',
    'gactivities',
    'health',
    'performance'];

  displayedColumnsOtherPeople: string[] = [
    'select',
    'name',
    'comments',
    'oneToOne',
    'projects',
    'gactivities',
    'health',
    'performance'];

  currentWeekEnding: Date;
  myStaffTabLabel: string;
  otherPeopleTabLabel: string;
  disabled: boolean;
  cantremove: boolean;
  selection = new SelectionModel<any>(true, []);
  dateCache: Date;
  selected = new FormControl(0);

  isTabDisabled = false;
  pendingData = false;

  /*date = new FormControl(
    'date', [
      Validators.required
    ]
  );*/

  constructor(public router: Router,
              public datepipe: DatePipe,
              private cookieService: CookieService,
              private staffActivityService: StaffActivityService,
              private emploeyeeDataService: EmployeeDataService,
              private dialog: MatDialog,
              private notification: MatSnackBar,
              private userLoginService: UserLoginService,
              private cDetector: ChangeDetectorRef) {
                this.loading = true;
                this.disabled = true;
                this.cantremove = true;
  }

  ngOnInit(): void {
    this.myStaffTabLabel = 'My Staff (0)';
    this.otherPeopleTabLabel = 'Other people (0)';
    //this.userName = this.cookieService.get('tok');
    this.userName = localStorage.getItem('tok');
    this.myEmployees = {};
    this.otherPeople = {};
    Promise.resolve().then(() => {
      this.notification.open('Fetching employee data.', 'Ok.', {
        duration: 2000
      });
      this.currentWeekEnding = this.staffActivityService.getWeekEnding(new Date(Date.now()));
      this.dateCache = this.currentWeekEnding;
      this.managerByEmailGet();
    });
  }

  dataChange(changedData): void {
    this.pendingData = true;
  }

  applyFilter(filterValue: string): void  {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterOtherPeople(filterValue: string): void  {
    this.dataSourceOtherPeople.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceOtherPeople.paginator) {
      this.dataSourceOtherPeople.paginator.firstPage();
    }
  }

  goHome(): void  {
    this.router.navigate(['/']);
  }

  logOut(): void  {
    if (!this.disabled) {
      this.checkData();
    }
  }

  getCountDataBool( data, key ): integer  {
    let count = 0;

    if ( data === null ||
        data === undefined ) {
      return 0;
    } else {
      data.data.forEach( ( elem ) => {
        if ( elem[key] === true ) {
          count++;
        }
      });
    }
    return count;
  }

  getValuePercentageCount( data, key, size ): integer {
    let value = 0;
    size = Number( size );

    if (data === null ||
        data === undefined ||
        size === 0 ) {
      return 100;
    } else {
      data.data.forEach( ( elem ) => {
        value += elem[key];
      });
      value = Math.ceil( value / size );
    }

    if ( value > 100 ) {
      value = 100;
    }
    return value;
  }

  managerByEmailGet(): void  {
    const _mngrid = localStorage.getItem('mngrid');
    this.emploeyeeDataService.getManagerByEmail().subscribe((managerEmployeeData) => {
      localStorage.setItem('managerData', JSON.stringify(managerEmployeeData));
      if (managerEmployeeData &&
          managerEmployeeData.managers &&
          Object.keys(managerEmployeeData.managers).length > 0 &&
          managerEmployeeData.managers.manager[0] &&
          managerEmployeeData.managers.manager[0].id) {
        const mngrid = managerEmployeeData.managers.manager[0].id;
        //this.cookieService.set('mngrid', mngrid, undefined, undefined, undefined, true, 'None');
        localStorage.setItem('mngrid', mngrid);
        // this.staffActivityGet();
        if (!this.employeeData) {
          this.emploeyeeDataService.getAllEmployees().subscribe((allEmmployeeData) => {
            localStorage.setItem('employeeData', JSON.stringify(allEmmployeeData));
            if(localStorage.getItem('esbExpired') && localStorage.getItem('esbExpired') === '1' ){
              localStorage.setItem('esbtimestamp', new Date().toISOString());
              localStorage.removeItem('esbExpired');
            }
            this.employeeDataFromEsb = allEmmployeeData;
            this.employeeData = new Array();
            this.allEmployees = new Array();
            this.otherPeopleEmployees = new Array();
            if (allEmmployeeData &&
                allEmmployeeData.staff &&
                allEmmployeeData.staff.employee &&
                allEmmployeeData.staff.employee.length > 0) {
              allEmmployeeData.staff.employee.sort((a, b) => a.fname.localeCompare(b.fname));
              allEmmployeeData.staff.employee.forEach((employee) => {
                let supervisedEmployee = false;
                if (employee.mgrId === mngrid) {
                  this.employeeData.push(employee);
                  supervisedEmployee = true;
                }

                if (employee.supervisor && employee.supervisor === 'false') {
                  this.allEmployees.push({
                    name: ((employee.fname) ? employee.fname : '') +
                    ((employee.fname) ? ' ' : '' ) +
                    ((employee.lname) ? employee.lname : ''),
                    id: (employee.id) ? employee.id : null
                  });

                  const currentEmployee = this.otherPeopleEmployees.find(x => x.id === employee.id);
                  if (!currentEmployee && !supervisedEmployee) {
                    this.otherPeopleEmployees.push({
                      name: ((employee.fname) ? employee.fname : '') +
                      ((employee.fname) ? ' ' : '' ) +
                      ((employee.lname) ? employee.lname : ''),
                      id: (employee.id) ? employee.id : null
                    });
                  }
                }
              });
            }
            this.staffActivityGet();
          });
        }
      } else {
        this.disabled = false;
        this.pendingData = false;
        this.isTabDisabled = false;
      }
    },
    error => {
      this.notification.open('Unkown error.', 'Ok.', {
        duration: 2000
      });
    });
  }

  staffActivityGet(): void  {
    this.notification.open('Fetching week ' + this.currentWeekEnding.toLocaleDateString() + '.', 'Ok.', {
      duration: 2000
    });
    this.staffActivityService.getStaffActivity(this.currentWeekEnding).subscribe((staff) => {
      this.myEmployees = Array();
      this.otherPeople = Array();
      //const managerId = this.cookieService.get('mngrid');
      const managerId = localStorage.getItem('mngrid');
      // Fill my staff data
      const staffAvailable = (staff && staff.items && staff.items.length > 0) ? true : false;
      const dynamoStaff = (staffAvailable) ? staff.items[0].staffData : new Array();
      const otherPeopleData = (staffAvailable) ? staff.items[0].otherPeopleData : new Array();
      this.staffActivityId = (staffAvailable) ? staff.items[0].staffActivityId : null;

      this.employeeData.forEach(employee => {
        if (employee.mgrId === managerId) {
          const staffUnit = (dynamoStaff.length > 0) ? dynamoStaff.find(x => x.staffKey === employee.id) : null;
          this.myEmployees.push({
            name: employee.fname + ' ' + employee.lname,
            comments: (staffUnit) ? staffUnit.comments : '-',
            oneToOne: (staffUnit) ? (staffUnit.one2One && staffUnit.one2One === 'N') ? false : true : false,
            projects: (employee.projects) ? employee.projects : '-',
            gActivities: (staffUnit) ? (staffUnit.groupActivities && staffUnit.groupActivities === 'N') ? false : true : false,
            health: (staffUnit) ? staffUnit.health : 80,
            performance: (staffUnit) ? staffUnit.performance : 80,
            id: employee.id
          });
        }
      });

      // Fill other people data
      if (otherPeopleData && otherPeopleData.length > 0) {
        otherPeopleData.forEach(employee => {
          const otherData = this.allEmployees.find(x => x.id === employee.staffKey);
          if (otherData) {
            this.otherPeople.push({
              name: otherData.name,
              comments: (employee) ? employee.comments : '-',
              oneToOne: (employee) ? (employee.one2One && employee.one2One === 'N') ? false : true : false,
              projects: (employee.projects) ? employee.projects : '-',
              gActivities: (employee) ? (employee.groupActivities && employee.groupActivities === 'N') ? false : true : false,
              health: (employee) ? employee.health : 80,
              performance: (employee) ? employee.performance : 80,
              id: employee.staffKey
            });
          }
        });
      }

      // Init my staff data
      this.dataSource = new MatTableDataSource(this.myEmployees);
      this.dataSource.paginator = this.paginatorMyStaff;
      this.dataSource.sort = this.sortMyStaff;

      // init other people data
      this.dataSourceOtherPeople = new MatTableDataSource(this.otherPeople);
      this.dataSourceOtherPeople.paginator = this.paginatorOtherPeople;
      this.dataSourceOtherPeople.sort = this.sortOtherPeople;

      this.myStaffTabLabel = 'My Staff (' + this.myEmployees.length + ')';
      this.otherPeopleTabLabel = 'Other people (' + this.otherPeople.length + ')';

      this.loading = false;
      this.notification.open('Data fetch complete.', 'Ok.', {
        duration: 2000
      });
      this.disabled = false;
      this.pendingData = false;
      this.isTabDisabled = false;
      /*if (staff && staff.Items.length <= 0) {
        this.dialog.open(ErrorDialogComponent, {
          data: {
              error: 'nodynamo'
          }
        });
      }*/
    });
  }

  addToOtherPeople(): void  {
    const existsEmployee = this.dataSourceOtherPeople.data.find( emp => emp.id === this.selectedOther ) ? true : false;
    if (this.selectedOther &&
        this.employeeDataFromEsb.staff.employee  &&
        existsEmployee === false ) {
      const other = this.employeeDataFromEsb.staff.employee.find(employee => employee.id === this.selectedOther);
      const otherData = this.allEmployees.find(x => x.id === this.selectedOther);
      this.otherPeople.push({
        name: otherData.name,
        comments: '-',
        oneToOne: false,
        projects: other.projects,
        gActivities: false,
        health: 80,
        performance: 80,
        id: otherData.id
      });
      // init other people data
      this.dataSourceOtherPeople = new MatTableDataSource(this.otherPeople);
      this.dataSourceOtherPeople.paginator = this.paginatorOtherPeople;
      this.dataSourceOtherPeople.sort = this.sortOtherPeople;
      this.otherPeopleTabLabel = 'Other people (' + this.otherPeople.length + ')';
      this.cDetector.detectChanges();
      this.pendingData = true;
    }

    if (existsEmployee) {
      this.notification.open('Employee already added.', 'Ok.', {
        duration: 5000
      });
    }
  }

  removeOtherPeople(): void  {
    if (this.selection && this.selection.selected.length > 0) {
      this.selection.selected.forEach(selected => {
        const index: number = this.otherPeople.indexOf(selected);
        if (index !== -1) {
          this.otherPeople.splice(index, 1);
        }
      });

      this.selection.clear();

      this.dataSourceOtherPeople = new MatTableDataSource(this.otherPeople);
      this.dataSourceOtherPeople.paginator = this.paginatorOtherPeople;
      this.dataSourceOtherPeople.sort = this.sortOtherPeople;
      this.otherPeopleTabLabel = 'Other people (' + this.otherPeople.length + ')';
      this.cDetector.detectChanges();
      this.pendingData = true;
    }
  }

  getColor(index): any {
    let currentColor = '';

    if ( index < 30 ) {
      currentColor = '#F65B4A';
    } else if ( index < 60 ) {
      currentColor = '#FFAF3E';
    } else if ( index < 80 ) {
      currentColor = '#4FC8ED';
    } else {
      currentColor = '#00BFAC';
    }

    return { color: currentColor };
  }

  checkData(dataType?: string, extradata?: string): void {
    if (this.pendingData) {
      this.disabled = true;
      this.isTabDisabled = true;
      this.cDetector.detectChanges();
      const dialogRef = this.dialog.open(SaveDialogComponent, {
        width: '300px',
        data: {action: (!dataType) ? 'log out' : 'change weeks' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result === 'cancel') {
            if (dataType) {
              this.currentWeekEnding = this.dateCache;
            }
            this.isTabDisabled = false;
            this.disabled = false;
            return;
          }
          if (result === 'discard') {
            this.continueAction(dataType, extradata);
          }
        }
      });
    } else {
      this.continueAction(dataType);
    }
  }

  continueAction(action?: string, extradata?: string): void {
    if (!action) {
      const ls = this.cDetector.checkNoChanges();
      this.userLoginService.logout();
      this.pendingData = false;
    } else {
      this.currentWeekEnding = this.staffActivityService.getWeekEnding(new Date(extradata));
      this.dateCache = this.currentWeekEnding;
      this.disabled = true;
      this.staffActivityGet();
    }
  }

  saveStaffActivity(): void {
    const ls = this.cDetector.checkNoChanges();
    this.notification.open('Saving data for week ' + this.currentWeekEnding.toLocaleDateString() + '.', 'Ok.', {
      duration: 2000
    });
    const dataToSave = {
      staffActivityId: this.staffActivityId,
      employees: this.myEmployees,
      otherStaff: this.otherPeople,
      weekEnding: this.currentWeekEnding.toLocaleDateString().replace(/\//g, '')
    };

    this.staffActivityService.saveStaffActivity(dataToSave).subscribe((data) => {
      if(!this.staffActivityId &&
        data.staffActivityId &&
        data.staffActivityId != '00000000-0000-0000-0000-000000000000'){
          this.staffActivityId = data.staffActivityId;
        }

      this.pendingData = false;
      this.notification.open('Save complete.', 'Ok.', {
        duration: 2000
      });
    });
  }

  exportStaffActivity(): void  {
    const ls = this.cDetector.checkNoChanges();
    setTimeout(() => {
      this.isTabDisabled = true;
      this.selected.setValue(0);

      const pdf = new jspdf('l', 'mm', 'letter');

      let staffCaption = ((this.userName) ? this.userName +
      '\'s Staff' : 'My Staff') +
      ' - Week Eding: ' +
      this.currentWeekEnding.toLocaleDateString();
      pdf.text('Date created: ' + this.getTodaysDate(), 14, 20);
      pdf.text(staffCaption, 14, 27);
      pdf.autoTable({
        head: this.getHeadRows('mine'),
        body: this.getStaffBody('mine'),
        startY: 30,
        rowPageBreak: 'auto',
          bodyStyles: { valign: 'top' },
          styles: {
            cellWidth: 'wrap'
          },
          headStyles: {
            fillColor: [246, 91, 74],
            fontSize: 15
          },
          columnStyles: {
            name: {
              cellWidth: '50'
            },
            comments: {
              cellWidth: '100'
            },
            oneToOne: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            projects: {
              cellWidth: '50'
            },
            gActivities: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            health: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            performance: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
          }
      });

      setTimeout(() => {
        this.selected.setValue(1);
        staffCaption = ((this.userName) ? this.userName +
          '\'s Other Staff' : 'Other Staff') +
          ' - Week Eding: ' +
          this.currentWeekEnding.toLocaleDateString();
        pdf.addPage();
        pdf.text(staffCaption, 14, 20);

        pdf.autoTable({
          head: this.getHeadRows('other'),
          body: this.getStaffBody('other'),
          startY: 25,
          rowPageBreak: 'auto',
          bodyStyles: { valign: 'top' },
          styles: {
            cellWidth: 'wrap'
          },
          headStyles: {
            fillColor: [246, 91, 74],
            fontSize: 15
          },
          columnStyles: {
            name: {
              cellWidth: '50'
            },
            comments: {
              cellWidth: '100'
            },
            oneToOne: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            projects: {
              cellWidth: '50'
            },
            gActivities: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            health: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
            performance: {
              cellWidth: '10',
              halign  : 'center',
              valign  : 'center'
            },
          }
        });
        this.selected.setValue(0);
        pdf.save('mystaff.pdf'); // Generated PDF
        this.isTabDisabled = false;
      }, 1000);
    }, 200);
  }

  setDate(action, event): void  {
    if (this.pendingData) {
      this.checkData('date', event.value);
    } else {
      this.currentWeekEnding = this.staffActivityService.getWeekEnding(new Date(event.value));
      this.disabled = true;
      this.staffActivityGet();
    }
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceOtherPeople.data.length;
    return numSelected === numRows;
  }

  masterToggle(): void  {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSourceOtherPeople.data.forEach(row => this.selection.select(row));
    }
  }

  getHeadRows(table): any {
    return [{
      name: (table === 'mine') ? 'MY STAFF' : 'OTHER STAFF',
      comments: 'COMMENTS',
      oneToOne: '1ON1',
      projects: 'PROJECTS',
      gActivities: 'GROUP ACTIV.',
      health: 'HEALTH',
      performance: 'PERFORM.'
    }];
  }

  getStaffBody(table): any {
    const currentS = (table === 'mine') ? this.myEmployees : this.otherPeople;
    const staffBody = [];

    currentS.forEach(employee => {
      staffBody.push({
        name: employee.name.trim(),
        comments: employee.comments.trim(),
        oneToOne: (employee.oneToOne) ? 'Y' : 'N',
        projects: employee.projects.trim(),
        gActivities: (employee.gActivities) ? 'Y' : 'N',
        health: employee.health + '%',
        performance: employee.performance + '%'
      });
    });

    return staffBody;
  }

  getTodaysDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    return mm + '/' + dd + '/' + yyyy;
  }
}
